
import { Component, Vue } from 'vue-property-decorator'
import MallProductService from '@/biz/service/Mall/MallProductService'

@Component
export default class MallProductIndex extends Vue {
  private MallProductService = MallProductService
}
